import React from "react";
import { Button, Typography, Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "../../styles/Carousel.css";
import { useAuth } from "../../contexts/AuthContext";

const { Title, Paragraph } = Typography;

const banners = [
  {
    title: "Build Skills With Online Course",
    desc: "Getting Quality Education is now more Easy and Affordable than ever.",
    img: process.env.PUBLIC_URL + "/imgs/banner1.png",
  },
  {
    title: "Learn Anytime Anywhere",
    desc: "Access our learning platform from any device and start building your future.",
    img: process.env.PUBLIC_URL + "/imgs/banner2.jpg",
  },
  {
    title: "Top Instructors From Around The World",
    desc: "Connect with experts and grow your skills with guided learning paths.",
    img: process.env.PUBLIC_URL + "/imgs/banner3.jpg",
  },
];

const CarouselComponent = () => {
  const { authenticated, login } = useAuth();
  const handleLogin = () => {
    login();
  };
  const carouselRef = React.useRef();

  return (
    <div className="custom-carousel" style={{ width: "100%", margin: "40px auto", position: "relative" }}>
      <Carousel
        ref={carouselRef}
        autoplay
        dots
        effect="scrollx"
        arrows={false}
      >
        {banners.map((banner, idx) => (
          <div key={idx}>
            <div
              className="carousel-bg-slide"
              style={{
                backgroundImage: `url(${banner.img})`,
              }}
            >
              <div className="carousel-overlay-content">
                <Title level={2}>{banner.title}</Title>
                <Paragraph className="carousel-desc">{banner.desc}</Paragraph>
                {!authenticated && (
                  <Button type="primary" onClick={handleLogin}>
                    Start Learning
                  </Button>
                )}
              </div>
            </div>
          </div>
        ))}
      </Carousel>
      <button
        className="carousel-arrow left"
        style={{
          position: "absolute",
          top: "50%",
          left: "10px",
          transform: "translateY(-50%)",
          zIndex: 2,
          background: "#fff",
          border: "none",
          borderRadius: "50%",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer"
        }}
        onClick={() => carouselRef.current.prev()}
      >
        <LeftOutlined />
      </button>
      <button
        className="carousel-arrow right"
        style={{
          position: "absolute",
          top: "50%",
          right: "10px",
          transform: "translateY(-50%)",
          zIndex: 2,
          background: "#fff",
          border: "none",
          borderRadius: "50%",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer"
        }}
        onClick={() => carouselRef.current.next()}
      >
        <RightOutlined />
      </button>
    </div>
  );
};

export default CarouselComponent;